const accordianItems = document.querySelectorAll(".js-accordian-item");

if (typeof accordianItems != "undefined" && accordianItems != null) {
    accordianItems.forEach((item) => {

        const buttonLine = item.querySelector(".js-accordian-button-vert-line");
        const hiddenContent = item.querySelector(".js-accordian-content");
        let rowState = hiddenContent.dataset.state;
    
        item.addEventListener("click", () => {
            if (rowState == 'false') {
                rowState = 'true';
                const showContent = gsap.timeline();
    
                showContent.
                to(buttonLine, {
                    duration: 0.1,
                    height: 0
                })
                .to(hiddenContent, {
                    duration: 0.1,
                    height: 'auto'
                })
                .to(hiddenContent, {
                    duration: 0.1,
                    autoAlpha: 1
                })
            } else {
                rowState = 'false';
                const hideContent = gsap.timeline();
                hideContent
                .to(hiddenContent, {
                    duration: 0.1,
                    autoAlpha: 0
                })
                .to(hiddenContent, {
                    duration: 0.1,
                    ease: Linear.none,
                    height: 0
                })
                .to(buttonLine, {
                    duration: 0.1,
                    height: '100%'
                })
            }
        });
    });
    
}
